var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NoData',{staticClass:"u-height-100"},[_c('v-row',_vm._b({staticClass:"u-height-100 py-0 px-0 my-0 mx-0"},'v-row',_vm.$attrs,false),[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }